const temp = null; export default temp;